export default __webpack_public_path__ + "static/media/dispenser-preview-image.58ff3ca6.png";